import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import PopConfirm from './_PopConfirm';
import Upload from '../../component/Inc/Upload';
function PopFinishReport(props) {
  const {open, close} = props;
  const [modalConfirm, setModalConfirm] = useState(false);
  return (
    <Modal open={open} close={close} type="com_input pop_school_report">
      <h2 className="pop_tit">수시보고서</h2>
      <div className="content_container scroll">
        <section className="search search_top">
          <input type="search" placeholder="검색할 내용을 입력해 주세요" className="input xs" />
          <button className="com_btn gray ws xs icon_search"></button>
        </section>
        <section className="search search_top">
          <select className="select">
            <option value="수업 과목 선택">수업 과목 선택</option>
          </select>
          <select className="select">
            <option value="보고서 회차 선택">보고서 회차 선택</option>
          </select>
        </section>
        <div className="com_input_upload">
          <Upload title="파일 등록" className="com_btn gray s wl" />
          <p className="file">
            <span className="txt">File name.pdf</span>
            <button type="button" className="btn_del_file" onClick={() => {}}></button>
            <button type="button" className="btn_down" onClick={() => {}}></button>
          </p>
        </div>
        <hr className="com_divider" />
        <div className="com_input_wrap">
          <select className="select">
            <option value="보고서 양식 선택">보고서 양식 선택</option>
          </select>
        </div>
        <div className="com_input_wrap">
          <input type="text" className="input" placeholder="제목 입력" />
        </div>
        <div className="com_board_box">
          <div className="board_item">
            <div className="editor">내용입력(에디터)</div>
            <p className="txt bold">생기부디자인 컨설팅(제안) 보고서</p>
            <p className="desc">Extracumicular axtivities design report1</p>
            <table className="com_board_list">
              <colgroup>
                <col width="50px" />
                <col width="20%" />
                <col />
                <col width="20%" />
              </colgroup>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>모집기관</th>
                  <th>상세 내용</th>
                  <th>연락처</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowSpan={2}>봉사활동</td>
                  <td>
                    훼밀리데이
                    <br />
                    케어센터
                  </td>
                  <td className="td_left">
                    어르신케어, 청소, 어르신 이동 <br />
                    도움 등<br />
                    모집 기간: ~2020.03.31
                    <br />
                    봉사 기간: ~2020.03.31
                  </td>
                  <td>02-400-9506</td>
                </tr>
                <tr>
                  <td className="border_left">
                    라이프케어 <br />
                    위례 케어센터
                  </td>
                  <td className="td_left">
                    어르신케어, 청소, 어르신 이동 <br />
                    도움 등<br />
                    모집 기간: ~2020.03.31
                    <br />
                    봉사 기간: ~2020.03.31
                  </td>
                  <td>02-6412-4827</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p className="alert_txt com_red_txt">* 등록, 수정시 학생에게 작성한 보고서가 메일로 자동 발송됩니다.</p>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
      <PopConfirm open={modalConfirm} close={() => setModalConfirm(false)} />
    </Modal>
  );
}

export default PopFinishReport;
